import { toggleEmployeeStatus } from "api/Employee";
import { UseMutationOptions, useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";


export const useToggleUserStatus = (
    options?: UseMutationOptions<any, any, any, unknown>
) => {
    const queryClient = useQueryClient();
    return useMutation(toggleEmployeeStatus, {
        onSuccess: () => {
            toast.success("Change employee status successfully!");
            queryClient.invalidateQueries('coustomers')
            queryClient.invalidateQueries('employes-profile')
        },
        onError: (error:any) => {
            toast.error(error.response.data.message ||  "Employee update failed! Please try again later.");
        },
        ...options
    })
}